import React from 'react';
import ResetPasswordContainer from 'containers/ResetPassword';

const ResetPassword = (props) => {
  return  (
    <>
    <ResetPasswordContainer {...props} />
    </>
  );
};

export default ResetPassword;
